// Keep the historical key so existing sessions retain deleted-template replacements.
const storageKey = (configId: string) =>
  `modern.deletedTemplateDefault.${configId}`;

export function rememberDeletedTemplateDefault(
  configId: string,
  replacementConfigId: string | null | undefined,
): void {
  sessionStorage.setItem(storageKey(configId), replacementConfigId ?? "");
}

export function sanitizeDeletedTemplateDefault(mergedConfig: unknown): unknown {
  if (
    !mergedConfig ||
    typeof mergedConfig !== "object" ||
    Array.isArray(mergedConfig)
  ) {
    return mergedConfig;
  }

  const config = mergedConfig as Record<string, unknown>;
  const defaultConfigId = config.defaultSpaceConfig?.toString();
  if (!defaultConfigId) return mergedConfig;

  const visited = new Set<string>();
  let resolvedConfigId = defaultConfigId;
  while (true) {
    if (visited.has(resolvedConfigId)) {
      resolvedConfigId = "";
      break;
    }
    visited.add(resolvedConfigId);

    const replacementConfigId = sessionStorage.getItem(
      storageKey(resolvedConfigId),
    );
    if (replacementConfigId === null) break;
    resolvedConfigId = replacementConfigId;
    if (!resolvedConfigId) break;
  }

  if (resolvedConfigId === defaultConfigId) return mergedConfig;

  return {
    ...config,
    defaultSpaceConfig: resolvedConfigId ? Number(resolvedConfigId) : null,
  };
}
